




































import { Component, Watch, Vue } from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";

@Component
export default class BannerHomeCard extends Vue {
  bannerItems: any[] = [];
  translations: any = RouteTranslations;

  @Watch("$i18n.locale", { immediate: true, deep: true })
  onLangChanged(val: string) {
    this.setMenuItems();
  }
  mounted() {
    this.setMenuItems();
  }
  setMenuItems() {
    this.bannerItems = [
      {
        label: this.$t("bannerHomeCard.tastingsLabel"),
        icon: "roomBannerHomeIcon.svg",
        link: "experiences",
        code: "tasting"
      },
      {
        label: this.$t("bannerHomeCard.roomsLabel"),
        icon: "tastingBannerHomeIcon.svg",
        link: "experiences",
        code: "stay"
      },
      {
        label: this.$t("bannerHomeCard.experiencesLabel"),
        icon: "experienceBannerHomeIcon.svg",
        link: "experiences",
        code: "special"
      },
      {
        label: this.$t("bannerHomeCard.eventsLabel"),
        icon: "eventBannerHomeIcon.svg",
        link: "experiences",
        code: "event"
      }
    ];
  }
  handleClick(link: string, index: string) {
    const toRoute: string = this.translations[this.$i18n.locale][link].link;
    this.$router.push({ path: toRoute, query: { expType: index } });
  }
}
